import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Tooltip, Menu, MenuItem, Grid } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { fieldMemberDelimiters } from '../../../utils/constants';
import { useStyles } from '../styles';

const TemplateFieldMemberDelimiter = props => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [delimiter, setDelimiter] = useState('Empty');
  const [anchorElement, setAnchorElement] = useState(null);

  useEffect(() => {
    setDelimiter(props.delimiter);
  }, [props.delimiter]);

  const handleClose = useCallback(() => {
    setAnchorElement(null);
  }, []);

  const handleDelimiterChange = useCallback(
    value => {
      setDelimiter(value || 'Empty');
      props.changeDelimiter(value);
      handleClose();
    },
    [handleClose, props]
  );

  return (
    <Grid container alignItems="center" justifyContent="center" item xs={1}>
      <Tooltip
        title={t('positionTemplateRule.delimiterExplanation')}
        placement="top"
        arrow
      >
        <Button
          id="delimiter-button"
          variant="outlined"
          color="primary"
          aria-label="delimiter"
          name="delimiter"
          onClick={event => setAnchorElement(event.target)}
          aria-controls="delimiter-menu"
          aria-haspopup="true"
          aria-expanded={anchorElement ? 'true' : undefined}
          classes={{ root: classes.DelimiterButton }}
        >
          {
            fieldMemberDelimiters.find(fmd => fmd.value === delimiter)
              .representation
          }
        </Button>
      </Tooltip>
      <Menu
        id="delimiter-menu"
        anchorEl={anchorElement}
        open={Boolean(anchorElement)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'delimiter-button',
        }}
      >
        {fieldMemberDelimiters.map(d => (
          <MenuItem
            key={d.value}
            onClick={() => handleDelimiterChange(d.value)}
            className={d.value === delimiter ? classes.SelectedDelimiter : ''}
          >
            {t(`fieldMemberDelimiter.${d.value}`)}
          </MenuItem>
        ))}
      </Menu>
    </Grid>
  );
};

TemplateFieldMemberDelimiter.propTypes = {
  delimiter: PropTypes.oneOf(['Empty', 'Space', 'Hyphen', 'Underscore']),
  changeDelimiter: PropTypes.func,
};

export default TemplateFieldMemberDelimiter;
